<dx-validation-group #validationGroup>
    @if(contactData){
        <div class="card border-0 shadow-sm pt-0 pb-4 mb-4">
            <div class="card-header fs-5 fw-medium">Contact</div>
            <div class="card-body">
                <div class="d-flex flex-row align-items-start gap-4 mb-4">
                    <form-photo
                        [link]="contactData?.avatarUrl"
                        [editable]="!isReadOnly"
                        [size]="80"
                        [uploadUrl]="avatarUploadUrl"
                    ></form-photo>
                    <div class="d-flex flex-column gap-2">
                        <div class="h5 mb-0">{{ contactData.name }}</div>
                        <div class="d-flex align-items-center text-muted">
                            {{ contactData.email }}
                            <dx-button
                                icon="copy"
                                stylingMode="text"
                                [activeStateEnabled]="false"
                                [focusStateEnabled]="false"
                                [hoverStateEnabled]="false"
                                (onClick)="copyToClipboard(contactData.email, $event)"
                            ></dx-button>
                            @if (canImpersonate) {
                                <dx-button
                                    icon="login"
                                    hint="Impersonate"
                                    stylingMode="text"
                                    [activeStateEnabled]="false"
                                    [focusStateEnabled]="false"
                                    [hoverStateEnabled]="false"
                                    (onClick)="onImpersonateClick(contactData.id)"
                                ></dx-button>
                            }
                        </div>
                        @if (!forceReadOnly && authService.canEditProfileSection(userId, PermissionType.UserPasswordResetOwn, PermissionType.UserPasswordResetOthers)) {
                            <dx-button
                                text="Change Password"
                                stylingMode="contained"
                                [icon]="(screen.xSmallScreenChanged | async) ? null : 'lock'"
                                (onClick)="onChangePasswordClick()"
                            ></dx-button>
                        }
                    </div>
                </div>

                <div class="row g-3">
                    <div class="col-md-4">
                        <label class="form-label">First Name</label>
                        <dx-text-box
                            [(value)]="contactData.firstName"
                            stylingMode="filled"
                            valueChangeEvent="input"
                            (onValueChanged)="onFieldChange()"
                            [readOnly]="isReadOnly"
                        >
                            <dx-validator>
                                <dxi-validation-rule type="required"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">Middle Name</label>
                        <dx-text-box
                            [(value)]="contactData.middleName"
                            stylingMode="filled"
                            valueChangeEvent="input"
                            (onValueChanged)="onFieldChange()"
                            [readOnly]="isReadOnly"
                        ></dx-text-box>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">Last Name</label>
                        <dx-text-box
                            [(value)]="contactData.lastName"
                            stylingMode="filled"
                            valueChangeEvent="input"
                            (onValueChanged)="onFieldChange()"
                            [readOnly]="isReadOnly"
                        >
                            <dx-validator>
                                <dxi-validation-rule type="required"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                    @if(canViewAlternativeName && alternativeName) {
                        <div class="col-md-6">
                            <label class="form-label">Alternative First Name</label>
                            <dx-text-box
                                [(value)]="alternativeName.alternativeFirstName"
                                stylingMode="filled"
                                valueChangeEvent="input"
                                (onValueChanged)="onFieldChange()"
                                [readOnly]="isAlternativeNameReadOnly"
                            >
                                <dx-validator #alternativeNameValidator>
                                    <dxi-validation-rule type="custom" [validationCallback]="validateAlternativeFirstName" message="Alternative first name is required when an alternative last name is provided."></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label">Alternative Last Name</label>
                            <dx-text-box
                                [(value)]="alternativeName.alternativeLastName"
                                stylingMode="filled"
                                valueChangeEvent="input"
                                (onValueChanged)="onFieldChange()"
                                [readOnly]="isAlternativeNameReadOnly"
                            >
                                <dx-validator #alternativeNameValidator>
                                    <dxi-validation-rule type="custom" [validationCallback]="validateAlternativeLastName" message="Alternative last name is required when an alternative first name is provided."></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    }
                    <div class="col-md-6">
                        <label class="form-label">Email Address</label>
                        <dx-text-box
                            [(value)]="contactData.email"
                            stylingMode="filled"
                            valueChangeEvent="input"
                            (onValueChanged)="onFieldChange()"
                            [readOnly]="isReadOnly"
                        >
                            <dx-validator>
                                <dxi-validation-rule type="required"></dxi-validation-rule>
                                <dxi-validation-rule type="email"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                    <div class="col-md-6">
                        <label class="form-label">Phone Number</label>
                        <dx-text-box
                            [(value)]="contactData.phone"
                            stylingMode="filled"
                            valueChangeEvent="input"
                            mask="(000) 000-0000"
                            (onValueChanged)="onFieldChange()"
                            [readOnly]="isReadOnly"
                        >
                            <dx-validator>
                                <dxi-validation-rule type="required"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                    <div class="col-12">
                        <label class="form-label">Address</label>
                        <dx-text-box
                            [(value)]="contactData.address"
                            stylingMode="filled"
                            valueChangeEvent="input"
                            (onValueChanged)="onFieldChange()"
                            [readOnly]="isReadOnly"
                        >
                            <dx-validator>
                                <dxi-validation-rule type="required"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
            </div>
        </div>
    }
</dx-validation-group>

